import { Endpoints } from "@config/Endpoints";
import { customAxios } from "@infrastructure/api/CustomAxios";

export const InvitationResource = {
  getInvitation: (invitationId: string) => {
    return customAxios.get(Endpoints.recipient.invitation(invitationId));
  },

  loginViaInvitation: (recipientId: string, kanguroPointId: string) => {
    return customAxios.post(Endpoints.auth.login_via_invitation, {
      recipientId: recipientId,
      kanguroPointId: kanguroPointId,
    });
  },
};
